import { first, isArray } from 'lodash-es';
import type { LocationQueryValue } from 'vue-router';

export const getSingle = <T extends LocationQueryValue>(input: T|T[]): T => {
    return isArray(input) ? first(input) : input;
};
